import React from 'react';
import { Box, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const NoResults = ({ illustrative = false, title, description, ...props }) => {
  const t = useLocalizedMessage();
  if (illustrative) return (
    <Box py={4} px={2} textAlign="center" color="text.secondary">
      <SearchIcon fontSize="large" />
      <Typography variant="h6" color="textPrimary">{title || t('searchInterface.preview.noResults')}</Typography>
      <Typography variant="body2">{description || t('searchInterface.preview.tryAnotherSearch')}</Typography>
    </Box>
  );
  return (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    py={4}
    px={2}
    bgcolor="#fafafa"
    borderRadius={1}
    border="1px dashed #e0e0e0"
    {...props}
  >
    <Box
      width={40}
      height={40}
      bgcolor="#e0e0e0"
      borderRadius={4}
      mb={2}
      position="relative"
    >
      <Box
        position="absolute"
        top="50%"
        left="50%"
        width={20}
        height={2}
        bgcolor="#bdbdbd"
        style={{ transform: 'translate(-50%, -50%) rotate(45deg)' }}
      />
      <Box
        position="absolute"
        top="50%"
        left="50%"
        width={20}
        height={2}
        bgcolor="#bdbdbd"
        style={{ transform: 'translate(-50%, -50%) rotate(-45deg)' }}
      />
    </Box>
    <Box width={120} height={12} bgcolor="#e0e0e0" borderRadius={6} mb={1} opacity={0.5} />
    <Box width={160} height={10} bgcolor="#e0e0e0" borderRadius={5} opacity={0.3} />
  </Box>
  );
};

export default NoResults;
